import { render, staticRenderFns } from "./BaseFilterableContainer.vue?vue&type=template&id=50ea7f52"
import script from "./BaseFilterableContainer.vue?vue&type=script&lang=ts"
export * from "./BaseFilterableContainer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports